module.exports = __webpack_public_path__ + "img/search_by_behaviors.5a98b803.gif";